// Module
var code = "<html> <head></head> <body style=\"margin:0;padding:0\"> <div class=\"%experimentVersion%\"> <button id=\"close\" class=\"close\" title=\"Close\"> <svg viewbox=\"0 0 40 40\"> <path class=\"close-x\" d=\"M 10,10 L 30,30 M 30,10 L 10,30\"/> </svg> </button> %bubbleLabel% <br/> </div> </body> </html> ";
// Exports
export default code;